import { FormSectionGroup } from '@vwfs-bronson/bronson-react';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { AddressFormNew } from '../../../../components/AddressFormNew';
import { BankDetailsNew } from '../../../../components/BankDetailsNew';
import { ContactDetailsFormNew } from '../../../../components/ContactDetailsFormNew';
import { TradingDetailsServicePlanFormNew } from '../../../../components/TradingDetailsServicePlanFormNew';
import { journeyDataSelectors } from '../../../../services/redux/features/journeyData.slice';
import { useFormSectionHelpers } from '../../../utils';

const orderedForms = ['tradingDetails', 'contactDetails', 'contactAddress', 'bankDetails'] as const;
type FormId = (typeof orderedForms)[number];

export const CustomerDataServicePlanBusinessSoleTrader = () => {
  const [forms, setForms] = useState<FormId[]>([...orderedForms]);
  // When in Standalone Service Plan user selected Upfront payment for service plan,
  // then we do not need Bank Details
  const isUpfrontPayment = useSelector(journeyDataSelectors.isUpfrontPayment);

  const getFormHelpers = useFormSectionHelpers(forms);

  useEffect(() => {
    const sections = [
      'tradingDetails',
      'contactAddress',
      'contactDetails',
      ...(isUpfrontPayment ? [] : (['bankDetails'] satisfies FormId[])),
    ] as FormId[];

    setForms(sections);
  }, [isUpfrontPayment]);

  return (
    <FormSectionGroup>
      <TradingDetailsServicePlanFormNew.SPB formHelpers={getFormHelpers('tradingDetails')} />
      <AddressFormNew.SPB formHelpers={getFormHelpers('contactAddress')} />
      <ContactDetailsFormNew.SPB
        formHelpers={getFormHelpers('contactDetails')}
        titleTranslationKey="contactDetailsForm:title:soleTrader"
      />
      {!isUpfrontPayment && (
        <BankDetailsNew.SPB
          formHelpers={getFormHelpers('bankDetails')}
          titleTranslationKey="bankDetailsForm:title:business"
        />
      )}
    </FormSectionGroup>
  );
};
